import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getPromoCodesLookups,
  getPromoCodesDatatable,
  createPromoCode,
  editPromoCode,
  assignPromoCodeToProductGroup,
  getPromoCodeById,
} from './thunks';
import { PromoCodesState } from './types';

export const name = 'promoCodes';

export const getPromoCodesLookupsAsync = createAsyncThunk(
  name + '/getPromoCodesLookups',
  getPromoCodesLookups
);

export const getPromoCodesDatatableAsync = createAsyncThunk(
  name + '/getPromoCodesDatatable',
  getPromoCodesDatatable
);

export const createPromoCodeAsync = createAsyncThunk(
  name + '/createPromoCode',
  createPromoCode
);

export const editPromoCodeAsync = createAsyncThunk(
  name + '/editPromoCode',
  editPromoCode
);

export const assignPromoCodeToProductGroupAsync = createAsyncThunk(
  name + '/assignPromoCodeToProductGroup',
  assignPromoCodeToProductGroup
);

export const getPromoCodeByIdAsync = createAsyncThunk(
  name + '/getPromoCodeById',
  getPromoCodeById
);

const initialState: PromoCodesState = {
  lookups: {
    data: [],
    status: 'idle',
  },
  promoCodesDatatable: {
    data: null,
    status: 'idle',
  },
  createPromoCode: {
    data: null,
    status: 'idle',
  },
  editPromoCode: {
    status: 'idle',
  },
  assignPromoCodeToProductGroup: {
    status: 'idle',
  },
  promoCodeById: {
    data: null,
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearPromoCode: (state) => {
      state.promoCodeById = {
        data: null,
        status: 'idle',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodesLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getPromoCodesLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodesLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(getPromoCodesDatatableAsync.pending, (state) => {
        state.promoCodesDatatable.status = 'loading';
      })
      .addCase(getPromoCodesDatatableAsync.fulfilled, (state, action) => {
        state.promoCodesDatatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodesDatatableAsync.rejected, (state) => {
        state.promoCodesDatatable.status = 'failed';
      })
      .addCase(createPromoCodeAsync.pending, (state) => {
        state.createPromoCode.status = 'loading';
      })
      .addCase(createPromoCodeAsync.fulfilled, (state, action) => {
        state.createPromoCode = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createPromoCodeAsync.rejected, (state) => {
        state.createPromoCode.status = 'failed';
      })
      .addCase(editPromoCodeAsync.pending, (state) => {
        state.editPromoCode.status = 'loading';
      })
      .addCase(editPromoCodeAsync.fulfilled, (state, action) => {
        state.editPromoCode = {
          status: 'idle',
        };
      })
      .addCase(editPromoCodeAsync.rejected, (state) => {
        state.editPromoCode.status = 'failed';
      })
      .addCase(assignPromoCodeToProductGroupAsync.pending, (state) => {
        state.assignPromoCodeToProductGroup.status = 'loading';
      })
      .addCase(assignPromoCodeToProductGroupAsync.fulfilled, (state) => {
        state.assignPromoCodeToProductGroup = {
          status: 'idle',
        };
      })
      .addCase(assignPromoCodeToProductGroupAsync.rejected, (state) => {
        state.assignPromoCodeToProductGroup.status = 'failed';
      })
      .addCase(getPromoCodeByIdAsync.pending, (state) => {
        state.promoCodeById.status = 'loading';
      })
      .addCase(getPromoCodeByIdAsync.fulfilled, (state, action) => {
        state.promoCodeById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPromoCodeByIdAsync.rejected, (state) => {
        state.promoCodeById.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
